import React, { ReactElement } from 'react';
import { PageProps } from 'gatsby';
import { PhotoSwipeGallery } from 'react-photoswipe';

import Headline from 'src/components/CE/Headline';
import { Background } from 'src/components/CE';
import DefaultLayout from 'src/layouts/DefaultLayout';

import bekifftes from 'src/img/lamas/bekifftes-lama.jpg';
import bekifftesThumb from 'src/img/lamas/bekifftes-lama-thumb.jpg';
import cute from 'src/img/lamas/cute-lama.jpg';
import cuteThumb from 'src/img/lamas/cute-lama-thumb.jpg';
import david from 'src/img/lamas/david-bowie-lama.jpg';
import davidThumb from 'src/img/lamas/david-bowie-lama-thumb.jpg';
import delrey from 'src/img/lamas/lama-del-rey.jpg';
import delreyThumb from 'src/img/lamas/lama-del-rey-thumb.jpg';
import fashion from 'src/img/lamas/fashion-lama.jpg';
import fashionThumb from 'src/img/lamas/fashion-lama-thumb.jpg';
import fleckvieh from 'src/img/lamas/fleckvieh-lama.jpg';
import fleckviehThumb from 'src/img/lamas/fleckvieh-lama-thumb.jpg';
import gang from 'src/img/lamas/lama-gang.jpg';
import gangThumb from 'src/img/lamas/lama-gang-thumb.jpg';
import hansii from 'src/img/lamas/hansii-lama.jpg';
import hansiiThumb from 'src/img/lamas/hansii-lama-thumb.jpg';
import hipster from 'src/img/lamas/hipster-lama.jpg';
import hipsterThumb from 'src/img/lamas/hipster-lama-thumb.jpg';
import kapitaen from 'src/img/lamas/kapitaen-lama.jpg';
import kapitaenThumb from 'src/img/lamas/kapitaen-lama-thumb.jpg';
import nini from 'src/img/lamas/nini-lama.jpg';
import niniThumb from 'src/img/lamas/nini-lama-thumb.jpg';
import nyan from 'src/img/lamas/nyan-lama.gif';
import pfeiff from 'src/img/lamas/ich-pfeiff-drauf-lama.jpg';
import pfeiffThumb from 'src/img/lamas/ich-pfeiff-drauf-lama-thumb.jpg';
import robbii from 'src/img/lamas/robbii-lama.jpg';
import robbiiThumb from 'src/img/lamas/robbii-lama-thumb.jpg';
import snow from 'src/img/lamas/snowlama.jpg';
import snowThumb from 'src/img/lamas/snowlama-thumb.jpg';
import travel from 'src/img/lamas/travel-lama.jpg';
import travelThumb from 'src/img/lamas/travel-lama-thumb.jpg';
import twins from 'src/img/lamas/lama-twins.jpg';
import twinsThumb from 'src/img/lamas/lama-twins-thumb.jpg';
import wald from 'src/img/lamas/wald-lama.jpg';
import waldThumb from 'src/img/lamas/wald-lama-thumb.jpg';

const images = [
  {
    src: snow,
    thumbnail: snowThumb,
    w: 870,
    h: 1000,
    title: 'Snow Lama',
  },
  {
    src: hansii,
    thumbnail: hansiiThumb,
    w: 500,
    h: 374,
    title: 'Hansii Lama',
  },
  {
    src: twins,
    thumbnail: twinsThumb,
    w: 500,
    h: 580,
    title: 'Lama Twins',
  },
  {
    src: david,
    thumbnail: davidThumb,
    w: 545,
    h: 555,
    title: 'David Bowie Lama',
  },
  {
    src: delrey,
    thumbnail: delreyThumb,
    w: 460,
    h: 459,
    title: 'Lama del Rey',
  },
  {
    src: nini,
    thumbnail: niniThumb,
    w: 397,
    h: 464,
    title: 'Ninii Lama',
  },
  {
    src: robbii,
    thumbnail: robbiiThumb,
    w: 526,
    h: 395,
    title: 'Robbii Lama',
  },
  {
    src: hipster,
    thumbnail: hipsterThumb,
    w: 410,
    h: 596,
    title: 'Hipster Lama',
  },
  {
    src: gang,
    thumbnail: gangThumb,
    w: 480,
    h: 600,
    title: 'Lama Gäng',
  },
  {
    src: travel,
    thumbnail: travelThumb,
    w: 316,
    h: 480,
    title: 'Travel Lama',
  },
  {
    src: nyan,
    thumbnail: nyan,
    w: 400,
    h: 400,
    title: 'Nyan Lama',
  },
  {
    src: fashion,
    thumbnail: fashionThumb,
    w: 1920,
    h: 1200,
    title: 'Fashion Lama',
  },
  {
    src: cute,
    thumbnail: cuteThumb,
    w: 425,
    h: 640,
    title: 'Hasi...',
  },
  {
    src: fleckvieh,
    thumbnail: fleckviehThumb,
    w: 1120,
    h: 840,
    title: 'Fleckvieh Lama',
  },
  {
    src: pfeiff,
    thumbnail: pfeiffThumb,
    w: 960,
    h: 640,
    title: 'Pffft - Lama',
  },
  {
    src: wald,
    thumbnail: waldThumb,
    w: 1200,
    h: 800,
    title: 'Waldlama',
  },
  {
    src: bekifftes,
    thumbnail: bekifftesThumb,
    w: 1800,
    h: 1200,
    title: 'Breiti Lama',
  },
  {
    src: kapitaen,
    thumbnail: kapitaenThumb,
    w: 1800,
    h: 1200,
    title: 'Ahoi Matrosen...',
  },
];

const Lamas = ({ location }: PageProps): ReactElement => (
  <DefaultLayout location={location}>
    <div className="ce-gallery">
      <Background styleName="lamas-rosa">
        <Headline size={1}>
          Wunderschöne Lamas und Alpakas
          <br />
          <small>Schaut doch mal...</small>
        </Headline>
      </Background>
      <div className="mb-20" />
      <PhotoSwipeGallery
        items={images}
        // eslint-disable-next-line react/no-unstable-nested-components
        thumbnailContent={(item) => (
          <img src={item.thumbnail} alt={item.title} />
        )}
        // disable history so page does not jump to top on close
        options={{ history: false }}
      />
    </div>
  </DefaultLayout>
);

export const frontmatter: PageFrontmatter = {
  browserTitle: 'Lamas und Alpakas aus dem Fröhlich ∧ Frei Zoo',
  metaDescription:
    'Wir mögen diese lustigen Tiere, denn vom Style-Faktor macht ihnen keiner was vor.',
  sitemapExclude: true,
  title: 'Lamas',
};

export default Lamas;
